import { forwardRef } from 'react';
import { AspectRatio as RadixAspectRatio } from '@radix-ui/themes';
import type { RadixAspectRatioProps } from '@/types/radix-ui';

/**
 * AspectRatio component - wrapper around Radix UI AspectRatio
 * Provides consistent aspect ratios for media content
 */
export type AspectRatioProps = RadixAspectRatioProps;

const AspectRatio = forwardRef<HTMLDivElement, AspectRatioProps>(
  (props, ref) => {
    return <RadixAspectRatio ref={ref} {...props} />;
  }
);

AspectRatio.displayName = 'AspectRatio';

export { AspectRatio };
